
export class Clock  {
    public get now(): number {
        return new Date().getTime();
    }
}

export class ManualClock extends Clock {
    private date: number;

    public setTime(date: number) {
        this.date = date;
    }

    public get now(): number {
        return this.date;
    }
}



// WEBPACK FOOTER //
// ./src/app/services/clock.ts